//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import common, { specState } from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";

import rollBox from '@/components/ui/rollBox'
import addrDialog from "./home/addressDialog";
import shopCart from "@/components/cusShopCart";
import mainMenuTab from "@/components/mainMenuTab";
import shopCategory from '@/components/shopCategoryList'

export default {
    components: {
        rollBox,
        shopCart,
        mainMenuTab,
        addrDialog,
        shopCategory
    },

    data() {
        return {
            bannerList: [],
            noticeList: [],
            goodsTypeList: [],
            storeList: [],
            currentStoreId: 0,
            defaultAvatar: 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80"><rect width="80" height="80" fill="%23f0f0f0"/><text x="50%25" y="55%25" font-size="28" text-anchor="middle" fill="%23bbb">店</text></svg>',
            hotGoodsList: [],

            scrolFlag: false,
            argeeDialog: {
                cartFlag: false,
            },
            goodsTypeDetailList: [],
            detailJson: [1, 2, 3],
            searchContent: "",
            goodsId: "",
            sms: {
                totalTime: 0,
                hour: 0,
                minute: 0,
                second: 0,
            },
            cartReset: {
                count: 1,
                current: 0,
            },

            goodsData: {
                goods_id: "",
            },
        };
    },
    methods: {

        // 重新查询
        reflush(){
            this.queryHotGoodsList();
            this.$refs.child.querySearchGoods()
        },

        cartDetail(item) {
            this.goodsData = item;
            this.argeeDialog.cartFlag = true;
        },

        // 查询banner列表图
        queryBannerList() {
            let _this = this;
            let opts = {
                url: api.bannerList,
                data: {},
                type: "get",
            };

            common.query(opts).then(
                (res) => {
                let data = res.data.forEach((val) => {
                    val.img = val.img + "";
                });
                _this.bannerList = res.data;
                },
                (res) => {
                _this.$vux.toast.text(res.message);
                }
            );
        },

        // 查询通知
        queryNoticeMsg(){
            let opts = {
                url: api.noticeMsgList,
                data: {},
                type: "get",
            };

            common.query(opts).then((res) => {
                this.noticeList = res.data;
                console.log(res.data);
            },(res) => {
                this.$vux.toast.text(res.message);
            }
            );
        },

        // 查询商品分类列表
        queryGoodsTypeList() {
            let _this = this;
            let opts = {
                url: api.goodsType,
                data: {},
                type: "get",
            };
            common.query(opts).then((res) => {
                _this.goodsTypeList = res.data;
            },(res) => {
                _this.$vux.toast.text(res.message);
            });
        },

        // 拉门店列表（带经纬度）
        queryStoreList() {
            let _this = this;
            let opts = {
                url: api.storeListWithLoc,
                data: {},
                type: "get",
            };
            common.query(opts).then((res) => {
                if (res.code === 0 && Array.isArray(res.data)) {
                    const list = res.data.map(s => Object.assign({}, s, {
                        shortName: (s.store_name || '').replace(/蛋蛋大王/g, '').replace(/店/g, '仓')
                    }));
                    _this.storeList = list;
                    _this.currentStoreId = common.getCurStoreId();
                }
            }, (res) => {
                _this.$vux.toast.text(res.message);
            });
        },

        // 切换当前门店
        selectStore(item) {
            if (!item || !item.store_id) return;
            common.setCurStore(item);
            this.currentStoreId = item.store_id;
            this.queryHotGoodsList();
            this.$refs.child && this.$refs.child.querySearchGoods();
        },

        // 查询秒杀商品列表
        queryHotGoodsList() {
            let _this = this;
            let opts = {
                url: api.hotGoodsList,
                data: {
                    storeId: common.getCurStoreId(),
                },
                type: "get",
            };
            common.query(opts).then(
                (res) => {
                _this.sms.totalTime = res.data.cool_down;
                res.data.list.forEach(function (v, i) {
                    v.goods_name = v.goods_name.slice(0, 6);
                });
                const handleSpec = new specState(res.data.list);
                const resData = handleSpec.resolve();
                _this.chunk(resData, 3);
                _this.countTime();
                },
                (res) => {
                _this.$vux.toast.text(res.message);
                }
            );
        },

        //跳转详情页
        goDetail(id) {
            this.$router.push({ name: "goodsDetail", query: { goodsid: id } });
        },

        // 倒计时
        countTime() {
        let _this = this;
        let h = this.sms.hour;
        let m = this.sms.minute;
        let s = this.sms.second;
        this.sms.totalTime = this.sms.totalTime - 1;
        if (this.sms.totalTime >= 0) {
            // d = Math.floor(_this.sms.totalTime/60/60/24);
            h = Math.floor((_this.sms.totalTime / 60 / 60) % 24);
            m = Math.floor((_this.sms.totalTime / 60) % 60);
            s = Math.floor(_this.sms.totalTime % 60);
            h = h < 10 ? "0" + h : h;
            m = m < 10 ? "0" + m : m;
            s = s < 10 ? "0" + s : s;
            _this.sms.second = s;
            _this.sms.hour = h;
            _this.sms.minute = m;
            setTimeout(function () {
            _this.countTime();
            }, 1000);
        } else {
            _this.sms.second = "00";
            _this.sms.hour = "00";
            _this.sms.minute = "00";
        }
        },

        //处理热卖商品
        chunk(arr, size) {
        for (var i = 0; i < arr.length; i = i + size) {
            this.hotGoodsList.push(arr.slice(i, i + size));
        }
        },

        goShops(id) {
            this.$router.push({ name: "storeList", query: { caryid: id } });
        },

        goMorderGoods() {
            this.$router.push({ name: "search" });
        },

        // 设置置顶按钮
        showIcon() {
            let scrollTop =
                document.documentElement.scrollTop ||
                document.body.scrollTop ||
                window.pageYOffset;
            console.log(scrollTop);
            if (
                !!document.documentElement.scrollTop &&
                document.documentElement.scrollTop > 200
            ) {
                this.scrolFlag = true;
            } else {
                this.scrolFlag = false;
            }
        },

        //点击置顶按钮定位顶部
        resetScrol() {
        document.documentElement.scrollTop = 0;
        console.log(this.searchContent);
        },

        handleScroll(e) {
        window.onscroll = function () {
            console.log(document.documentElement.scrollTop);
        };
        },

        // 获取搜索内容并跳转到搜索页
        CheckInfo() {
        let _this = this;
        if (event.keyCode == 13) {
            _this.$router.push({
            name: "search",
            query: { sContent: _this.searchContent },
            });
        }
        },

    },
    mounted() {
        this.queryBannerList();
        this.queryStoreList();
        this.queryNoticeMsg();
        this.queryGoodsTypeList();
        // this.queryHotGoodsList();
        //    this.countTime()
        // this.showIcon();

    },
};



// WEBPACK FOOTER //
// ./src/views/pages/home.vue